import script from "./casePop.vue?vue&type=script&setup=true&lang=js"
export * from "./casePop.vue?vue&type=script&setup=true&lang=js"

import "./casePop.vue?vue&type=style&index=0&id=7e84b3c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e84b3c0"]])

export default __exports__